// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uaM7","delete":"styles_delete__219D0","update":"styles_update__VEZr-","add":"styles_add__3Cp-8"};